import $router from "@/router";
import $moment from "moment-timezone";
import "@/assets/js/clamp.js";
import { i18n } from "@/main.js";
import store from "@/store";
import $config from "@/app.config.js";

const helpers = {
  // go to route
  goTo: (name, params = null, query = null) => {
    console.log("GO TO", name, params, query);
    const obj = { name };
    if (params) obj.params = params;
    if (query) obj.query = query;
    $router.push(obj);
  },
  formatValue: (key, value, timezone) => {
    switch (key) {
      case "none":
        return value;
      case "secondsToTime":
        return helpers.formatSecondsToTime(value, timezone);
      case "dateTime":
        return helpers.formatDateTime(value, timezone);
      case "date":
        return helpers.formatDate(value, timezone);
      case "dateFromNow":
        return helpers.formatDate(value, timezone, true);
      case "dateWithoutTime":
        return helpers.formatDate(value, timezone, false, true);
      case "name":
        return helpers.formatName(value);
      case "nameSpeech":
        return helpers.formatName(value);
      case "address":
        return helpers.formatAddress(value);
      case "gender":
        return helpers.formatGender(value);
      case "title":
        return helpers.formatTitle(value);
      case "owner":
        return helpers.formatOwner(value);
      case "projectStatus":
        return helpers.formatStatus(value, "project");
      case "userStatus":
        return helpers.formatStatus(value, "user");
      case "formatImportStatus":
        return helpers.formatImportStatus(value);
      case "pwProtected":
        return helpers.formatPwProtected(value);
      case "template":
        return helpers.formatTemplate(value);
      case "country":
        return helpers.formatCountry(value);
      case "size":
        return helpers.formatFileSize(value);
      // case 'type':
      //   return helpers.formatFileType(value)
      case "locale":
        return helpers.formatLocale(value);
      case "templateSnippetsDefault":
        return helpers.templateSnippetsStatus(value, "default");
      case "templateSnippetsType":
        return helpers.templateSnippetsStatus(value, "type");
      case "theme":
        return helpers.formatTheme(value);
      case "timezone":
        return helpers.formatTimezone(value);
      case "archived":
        return helpers.formatArchived(value);
      case "role":
        return helpers.formatRole(value);
    }
  },
  escape(str) {
    const htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "/": "&#x2F;",
    };
    const allowedTags = {
      "<ul>": "%ul%",
      "</ul>": "%uul%",
      "<li>": "%li%",
      "</li>": "%lli%",
    };
    const htmlEscaper = /[&<>"'/]/g;
    const escapeHtml = function (string) {
      return ("" + string).replace(htmlEscaper, function (match) {
        return htmlEscapes[match];
      });
    };
    if (str && str !== "") {
      str = str.toString();
      str = str.replace(/<br\/>/gi, "%br%");
      str = str.replace(/<b>/gi, "%b%");
      str = str.replace(/<\/b>/gi, "%bb%");
      str = str.replace(/<h1>/gi, "%h1%");
      str = str.replace(/<\/h1>/gi, "%hh1%");
      if (this.has_html) {
        for (let a in allowedTags) {
          let re = new RegExp(a, "gi");
          str = str.replace(re, allowedTags[a]);
        }
      }
      str = escapeHtml(str);
      str = str.replace(/%br%?/gi, "<br/>");
      str = str.replace(/%b%/gi, "<b>");
      str = str.replace(/%bb%/gi, "</b>");
      str = str.replace(/%h1%/gi, "<h1>");
      str = str.replace(/%hh1%/gi, "</h1>");
      if (this.has_html) {
        for (let a in allowedTags) {
          let re = new RegExp(allowedTags[a], "gi");
          str = str.replace(re, a);
        }
      }
    }
    return str;
  },
  replaceLineBreaks(str) {
    return str.replace(/%br%?/gi, "<br/>");
  },
  formatName: (client, speech = false) => {
    if (client) {
      const lastName = client.last_name ? client.last_name : "";
      const firstName = client.first_name ? client.first_name : "";
      const lastNameConnector = speech ? (firstName ? " " : "") : lastName && firstName ? ", " : "";
      return speech ? firstName + lastNameConnector + lastName : lastName + lastNameConnector + firstName;
    } else {
      return "";
    }
  },
  formatNameWithRole: (client, speech = false) => {
    if (client) {
      const lastName = client.last_name ? client.last_name : "";
      const firstName = client.first_name ? client.first_name : "";
      const lastNameConnector = speech ? (firstName ? " " : "") : lastName && firstName ? ", " : "";
      const role = client.role ? " " + i18n.t("labels." + client.role) : "";
      return speech ? firstName + lastNameConnector + lastName + role : lastName + lastNameConnector + firstName + role;
    } else {
      return "";
    }
  },
  formatStatusColor: (status) => {
    let color;
    if (
      (status & store.getters.projects_get_projects_stati.POSTED.bit) ===
        store.getters.projects_get_projects_stati.POSTED.bit &&
      (status & store.getters.projects_get_projects_stati.VISITED.bit) !==
        store.getters.projects_get_projects_stati.VISITED.bit
    ) {
      color = "#F6CD79 #F6CD79 white";
    } else if (
      (status & store.getters.projects_get_projects_stati.VISITED.bit) ===
      store.getters.projects_get_projects_stati.VISITED.bit
    ) {
      color = "#13C46A #13C46A white";
    } else {
      color = "#FC6D6D #FC6D6D white";
    }
    return color;
  },
  formatStatus: (status, key) => {
    let active = i18n.t("stati.listValues.default");
    if (key === "project") {
      active = i18n.t("stati.listValues.new");
      if (
        (status & store.getters.projects_get_projects_stati.POSTED.bit) ===
        store.getters.projects_get_projects_stati.POSTED.bit
      ) {
        active = i18n.t("stati.listValues.sent");
      }
      if (
        (status & store.getters.projects_get_projects_stati.VISITED.bit) ===
        store.getters.projects_get_projects_stati.VISITED.bit
      ) {
        active = i18n.t("stati.listValues.visited");
      }
    } else if (key === "user") {
      if (
        (status & store.getters.user_get_users_stati.INVITED.bit) ===
        store.getters.user_get_users_stati.INVITED.bit
      ) {
        active = i18n.t("stati.listValues.invited");
      }
      if ((status & store.getters.user_get_users_stati.ACTIVE.bit) === store.getters.user_get_users_stati.ACTIVE.bit) {
        active = i18n.t("stati.listValues.activated");
      }
      if (
        (status & store.getters.user_get_users_stati.INVITED.bit) !== store.getters.user_get_users_stati.INVITED.bit &&
        (status & store.getters.user_get_users_stati.ACTIVE.bit) !== store.getters.user_get_users_stati.ACTIVE.bit
      ) {
        active = i18n.t("stati.listValues.deactivated");
      }
    }
    return active;
  },
  setStatusColor: (status, key) => {
    let color = "black";
    if (key === "project") {
      color = "red";
      if (
        (status & store.getters.projects_get_projects_stati.POSTED.bit) ===
        store.getters.projects_get_projects_stati.POSTED.bit
      ) {
        color = "yellow";
      }
      if (
        (status & store.getters.projects_get_projects_stati.VISITED.bit) ===
        store.getters.projects_get_projects_stati.VISITED.bit
      ) {
        color = "green";
      }
    }
    return color;
  },
  formatArchived: (status) => {
    if (
      (status & store.getters.projects_get_projects_stati.ARCHIVED.bit) ===
      store.getters.projects_get_projects_stati.ARCHIVED.bit
    ) {
      return i18n.t("project.yes");
    } else {
      return i18n.t("project.no");
    }
  },
  templateSnippetsStatus: (status, key = "type", translated = true) => {
    const active = i18n.t("stati.listValues.default");
    if (key === "type") {
      if (
        (status & store.getters.templates_get_current_template_snippets_meta.status.TEXT.bit) ===
        store.getters.templates_get_current_template_snippets_meta.status.TEXT.bit
      ) {
        return translated ? i18n.t("templateSnippets.status.text") : "text";
      }
      if (
        (status & store.getters.templates_get_current_template_snippets_meta.status.EMAIL.bit) ===
        store.getters.templates_get_current_template_snippets_meta.status.EMAIL.bit
      ) {
        return translated ? i18n.t("templateSnippets.status.email") : "email";
      }
    } else if (key === "default") {
      if (
        (status & store.getters.templates_get_current_template_snippets_meta.status.DEFAULT.bit) ===
        store.getters.templates_get_current_template_snippets_meta.status.DEFAULT.bit
      ) {
        return translated ? i18n.t("labels.yes") : true;
      }
      return translated ? i18n.t("labels.no") : false;
    }
    return translated ? active : null;
  },
  formatImportStatus(status) {
    if (
      (status & store.getters.import_get_imports_meta.status.IMPORTED.bit) ===
      store.getters.import_get_imports_meta.status.IMPORTED.bit
    ) {
      return i18n.t("imports.status.imported");
    } else if (
      (status & store.getters.import_get_imports_meta.status.IMPORT_ERROR.bit) ===
      store.getters.import_get_imports_meta.status.IMPORT_ERROR.bit
    ) {
      return i18n.t("imports.status.import_error");
    } else if (
      (status & store.getters.import_get_imports_meta.status.IN_PROGRESS.bit) ===
      store.getters.import_get_imports_meta.status.IN_PROGRESS.bit
    ) {
      return i18n.t("imports.status.in_progress");
    }
    return i18n.t("imports.status.init");
  },
  formatStatusTitle: (obj, locale) => {
    if (typeof obj !== "undefined") {
      if (obj.title[locale]) {
        return obj.title[locale];
      } else if (obj.title.default) {
        return obj.title.default;
      } else {
        return "No title";
      }
    } else {
      return "No title";
    }
  },
  formatTemplate(template) {
    return template.name;
  },
  formatFileListGroupName(lists) {
    if (lists && lists.length > 0) {
      const names = [];
      lists.forEach((item) => names.push(item.display_name));
      return names.join(", ");
    }
    return "";
  },
  formatPwProtected(state) {
    return state ? i18n.t("project.private.true") : i18n.t("project.private.false");
  },
  formatOwner: (owner) => {
    return helpers.formatName(owner) + (owner.company ? "<br/>" + owner.company : "");
  },
  formatDate: (date, timezone, fromNow = false, withoutTime = false, asCalendar = false) => {
    if (date) {
      if (!timezone || timezone === "") timezone = "Europe/Berlin";
      return fromNow
        ? $moment(date).fromNow()
        : withoutTime
        ? $moment(date).tz(timezone).format("L")
        : asCalendar
        ? $moment(date).tz(timezone).calendar(null, {
            sameElse: "LLLL",
          })
        : $moment(date).tz(timezone).format("L HH:mm");
    } else {
      return "";
    }
  },
  formatDateTime: (date, timezone) => {
    if (date) {
      if (!timezone || timezone === "") timezone = "Europe/Berlin";
      return $moment(date).tz(timezone).format("L HH:mm:ss");
    } else {
      return "";
    }
  },
  formatTime: (date, timezone, withSeconds = true) => {
    if (date) {
      if (!timezone || timezone === "") timezone = "Europe/Berlin";

      let timeFormat = "HH:mm:ss";
      if (!withSeconds) {
        timeFormat = "HH:mm";
      }

      return $moment(date).tz(timezone).format(timeFormat);
    } else {
      return "";
    }
  },
  formatSecondsToTime: (seconds) => {
    const duration = $moment.duration(Math.abs(seconds), "seconds");

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const secs = duration.seconds();

    const parts = [];

    if (days) {
      parts.push(`${days} ${days === 1 ? i18n.t("time.day") : i18n.t("time.days")}`);
    }
    if (hours) {
      parts.push(`${hours} ${hours === 1 ? i18n.t("time.hour") : i18n.t("time.hours")}`);
    }
    if (minutes) {
      parts.push(`${minutes} ${minutes === 1 ? i18n.t("time.minute") : i18n.t("time.minutes")}`);
    }
    // Sekunden nur anzeigen, wenn Stunden und Tage 0 sind
    if (secs && hours === 0 && days === 0) {
      parts.push(`${secs} ${secs === 1 ? i18n.t("time.second") : i18n.t("time.seconds")}`);
    }

    let result = parts.join(", ");
    if (seconds < 0) {
      result += " (" + i18n.t("time.pending") + ")";
    }

    return result;
  },
  formatCountry: (shortcode) => {
    const countries = i18n.t("countries");
    return countries[shortcode] ? countries[shortcode] : "";
  },
  formatAddress: (client) => {
    const street = client.street ? client.street + ", " : "";
    const zip = client.zip ? client.zip + ", " : "";
    const city = client.city ? client.city + ", " : "";
    const country = client.country ? client.country : "";
    return street + zip + city + country;
  },
  formatGender: (gender) => {
    return gender === null ? i18n.t("gender.none") : gender === "f" ? i18n.t("gender.female") : i18n.t("gender.male");
  },
  formatTitle: (title) => {
    return title === null ? i18n.t("title.none") : title === "f" ? i18n.t("title.female") : i18n.t("title.male");
  },
  formatLocale: (client) => {
    const langs = i18n.t("lang");
    return client.locale ? i18n.t("lang." + client.locale) : langs[client] ? i18n.t("lang." + client) : "";
  },
  formatActivity(project, timezone) {
    return project.last_active_at ? this.formatDate(project.last_active_at, timezone, true) : "";
  },
  formatFileSize(bytes, decimal = true) {
    const thresh = decimal ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
      return bytes + " B";
    }
    const units = decimal
      ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
    let u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + " " + units[u];
  },
  formatNumber(number, digits) {
    const si = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = si.length - 1; i > 0; i--) {
      if (number >= si[i].value) {
        break;
      }
    }
    return (number / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
  },
  stringToColour(str) {
    let color = "";
    if (str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      color = "#";
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xff;
        color += ("00" + value.toString(16)).substr(-2);
      }
    } else {
      color = "red";
    }
    return color;
  },
  formatVisitor(uid, visitors) {
    return visitors.find((obj) => obj.uid === uid);
  },
  formatAgent(agent) {
    let obj = {};
    if (agent.browser) {
      if (agent.browser.includes("Chrome")) {
        obj.browser = "fa-chrome";
      } else if (agent.browser.includes("Opera")) {
        obj.browser = "fa-opera";
      } else if (agent.browser.includes("Safari")) {
        obj.browser = "fa-safari";
      } else if (agent.browser.includes("Firefox")) {
        obj.browser = "fa-firefox";
      } else if (agent.browser.includes("Edge")) {
        obj.browser = "fa-edge";
      } else {
        obj.browser = "fa-default-browser";
      }
    } else {
      obj.browser = "fa-default-browser";
    }
    if (agent.platform) {
      if (agent.platform.includes("OS X")) {
        obj.platform = "fa-apple";
      } else if (agent.platform.includes("Windows")) {
        obj.platform = "fa-windows";
      } else if (agent.platform.includes("AndroidOS")) {
        obj.platform = "fa-android";
      } else if (
        agent.platform.includes("Linux") ||
        agent.platform.includes("Debian") ||
        agent.platform.includes("Ubuntu")
      ) {
        obj.platform = "fa-linux";
      } else {
        obj.platform = "fa-default-platform";
      }
    } else {
      obj.platform = "fa-default-platform";
    }
    if (agent.isMobile) {
      obj.isMobile = "fa-mobile";
    } else {
      obj.isMobile = "fa-laptop";
    }
    return obj;
  },
  formatTimezone(timezone) {
    let label = "";
    const timezones = i18n.t("timezones");
    for (let i = 0; i < timezones.length; i += 1) {
      if (timezones[i].value === timezone) {
        label = timezones[i].label;
        break;
      }
    }
    return label;
  },
  getOrderedGenderArray(genderArray) {
    let returnArray = [
      {
        key: "default",
        value: genderArray.default,
      },
    ];
    if (Object.prototype.hasOwnProperty.call(genderArray, "f")) {
      returnArray.push({
        key: "f",
        value: genderArray.f,
      });
    }
    if (Object.prototype.hasOwnProperty.call(genderArray, "m")) {
      returnArray.push({
        key: "m",
        value: genderArray.m,
      });
    }
    return returnArray;
  },
  getOrderedGenderArrayWithoutDefault(genderArray) {
    let returnArray = [];
    if (Object.prototype.hasOwnProperty.call(genderArray, "f")) {
      returnArray.push({
        key: "f",
        value: genderArray.f,
      });
    }
    if (Object.prototype.hasOwnProperty.call(genderArray, "m")) {
      returnArray.push({
        key: "m",
        value: genderArray.m,
      });
    }
    return returnArray;
  },
  getNameFromClientsByUid(uid, clients) {
    if (uid) {
      const client = clients.find((obj) => {
        return obj.uid === uid;
      });
      return this.formatName(client);
    } else {
      return "";
    }
  },
  getNameFromLibraryByUid(uid, type, library, currentFolder) {
    if (uid) {
      let element = null;
      if (type === "folders") {
        element = currentFolder;
        if (currentFolder && uid === currentFolder.uid) {
          element = currentFolder;
        } else {
          element = library.folders.find((obj) => {
            return obj.uid === uid;
          });
        }
      } else {
        element = library.files.find((obj) => {
          return obj.uid === uid;
        });
      }
      return element ? element.title : "";
    } else {
      return "";
    }
  },
  getNameFromSnippetByUid(uid, snippets) {
    if (uid) {
      const snippet = snippets.find((obj) => {
        return obj.uid === uid;
      });
      return snippet.name;
    } else {
      return "";
    }
  },
  getNameFromProjectsByUid(uid, projects) {
    if (uid) {
      const project = projects.find((obj) => {
        return obj.uid === uid;
      });
      return project.title;
    } else {
      return "";
    }
  },
  getNameFromFilesByUid(uid, files) {
    if (uid) {
      const file = files.find((obj) => {
        return obj.uid === uid;
      });
      return file.title;
    } else {
      return "";
    }
  },
  getNameFromTeamMembersByUid(uid, teamMembers) {
    if (uid) {
      const teamMember = teamMembers.find((obj) => {
        return obj.uid === uid;
      });
      return teamMember.last_name + ", " + teamMember.first_name;
    } else {
      return "";
    }
  },
  createUniqueUid() {
    return "_" + Math.random().toString(36).substr(2, 9);
  },
  getLanguageValue(obj, lang = false) {
    if (obj) {
      const locale = lang ? lang : i18n.locale;
      if (Object.prototype.hasOwnProperty.call(obj, locale)) {
        return obj[locale];
      } else if (Object.prototype.hasOwnProperty.call(obj, "default")) {
        return obj.default;
      } else {
        const values = Object.values(obj);
        if (values.length) {
          return values[0];
        }
      }
    }
    return "";
  },
  getInitials(client) {
    let firstName;
    let lastName;
    client.first_name ? (firstName = client.first_name) : (firstName = "");
    client.last_name ? (lastName = client.last_name) : (lastName = "");
    return firstName.charAt(0) + lastName.charAt(0);
  },
  sessionStorageTransfer(event) {
    console.log("***** DEBUG SESSION TRANSFER ***** event.key", event.key);
    if (!event) {
      event = window.event;
    } // ie
    // if (!event.newValue) return
    let localSession;
    let session;
    if (event.key === "localStorageEnvivo") {
      localSession = JSON.parse(localStorage.getItem("localStorageEnvivo"));
      session = JSON.parse(sessionStorage.getItem("sessionStorageEnvivo"));
      const orderedSession = {};
      if (session) {
        Object.keys(session)
          .sort()
          .forEach((key) => {
            orderedSession[key] = session[key];
          });
      }
      console.log("***** DEBUG SESSION TRANSFER ***** localSession", localSession);
      console.log("***** DEBUG SESSION TRANSFER ***** session", session);
      console.log("***** DEBUG SESSION TRANSFER ***** orderedSession", orderedSession);
      console.log(
        "***** DEBUG SESSION TRANSFER ***** compare",
        JSON.stringify(localSession) !== JSON.stringify(orderedSession)
      );
      if (
        orderedSession[$router.currentRoute.params.team] &&
        JSON.stringify(localSession) !== JSON.stringify(orderedSession)
      ) {
        const addSession = {};
        addSession[$router.currentRoute.params.team] = orderedSession[$router.currentRoute.params.team];
        const storageData = Object.assign({}, addSession, localSession);
        console.log(
          "***** DEBUG SESSION TRANSFER ***** new data for locale & session",
          session,
          addSession,
          localSession,
          storageData
        );
        sessionStorage.setItem("sessionStorageEnvivo", JSON.stringify(storageData));
        localStorage.setItem("localStorageEnvivo", JSON.stringify(storageData));
        localSession = JSON.parse(localStorage.getItem("localStorageEnvivo"));
        console.log("***** DEBUG SESSION TRANSFER ***** localSession or login", localSession);
        if (!localSession || !localSession[$router.currentRoute.params.team]) {
          $router.push("/login");
        }
      }
    }
  },
  checkObjectIsEmpty(obj) {
    return obj !== null ? Object.keys(obj).length === 0 && obj.constructor === Object : false;
  },
  getTeamObjectBySlug(teams, slug) {
    let currentKey = "default";
    Object.keys(teams).forEach((key) => {
      if (teams[key].team && teams[key].team.slug === slug) {
        currentKey = key;
      }
    });
    return teams[currentKey];
  },
  formatTheme(theme) {
    return theme.name ? theme.name : "";
  },
  formatLanguagesAsString(shortcodes) {
    const res = [];
    shortcodes.forEach((shortcode) => {
      res.push(i18n.t("lang." + shortcode));
    });
    return res.join(" | ");
  },
  isMobile() {
    return false;
    // if (navigator.userAgent.match(/Mobi/)) return true
    // if ('screen' in window && window.screen.width < 1366) return true
    // const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    // if (connection && connection.type === 'cellular') return true
    // return false
  },
  isTouchDevice() {
    let supportsTouch = false;
    if ("ontouchstart" in window) {
      // iOS & android
      supportsTouch = true;
    } else if (window.navigator.msPointerEnabled) {
      // Win8
      supportsTouch = true;
    } else if ("ontouchstart" in document.documentElement) {
      // Controversal way to check touch support
      supportsTouch = true;
    }
    return supportsTouch;
  },
  toggleHtmlScroll(start = true) {
    if (start) {
      const htmlClass = document.documentElement.className;
      document.documentElement.className = htmlClass === "scroll" ? "hide" : "scroll";
    }
    document.documentElement.className === "hide"
      ? (document.body.className = "v--modal-block-scroll")
      : (document.body.className = "");
  },
  isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
  },
  mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (this.isObject(target) && this.isObject(source)) {
      for (const key in source) {
        if (this.isObject(source[key])) {
          if (!target[key]) {
            Object.assign(target, {
              [key]: {},
            });
          }
          this.mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, {
            [key]: source[key],
          });
        }
      }
    }
    return this.mergeDeep(target, ...sources);
  },
  sortObjByKey(value) {
    return typeof value === "object"
      ? Array.isArray(value)
        ? value.map(this.sortObjByKey)
        : Object.keys(value)
            .sort()
            .reduce((o, key) => {
              const v = value[key];
              o[key] = this.sortObjByKey(v);
              return o;
            }, {})
      : value;
  },
  objectsAreEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  },
  formatFilterPresetName(preset, lang = false) {
    if (preset.is_global) {
      if (preset.display_name) {
        if (preset.display_name[lang]) {
          return preset.display_name[lang];
        } else if (preset.display_name.default) {
          return preset.display_name.default;
        }
      } else {
        return "";
      }
    } else if (preset.name) {
      return preset.name;
    } else {
      return "";
    }
  },
  formatCustomErrorMessage(err, locale) {
    let body = "";
    let title = "";
    Object.keys(err.data.error.custom.body).forEach((key) => {
      if (key === locale) {
        body = err.data.error.custom.body[locale];
      } else {
        body = err.data.error.custom.body.default;
      }
    });
    Object.keys(err.data.error.custom.body).forEach((key) => {
      if (key === locale) {
        title = err.data.error.custom.title[locale];
      } else {
        title = err.data.error.custom.title.default;
      }
    });
    return { body, title };
  },
  showSubscriptionErrorModal(thisModal, owner = false) {
    let modal = {};
    if (owner) {
      modal = {
        body: i18n.t("modals.errorTeamPermissionMissing.text.owner"),
        title: i18n.t("modals.errorTeamPermissionMissing.title"),
        secondaryButtonCb: () => {
          return this.goTo("Settings", { tab: "team", scroll: true });
        },
        secondaryButtonText: i18n.t("actions.manageSubscription"),
      };
    } else {
      modal = {
        body: i18n.t("modals.errorTeamPermissionMissing.text.user"),
        title: i18n.t("modals.errorTeamPermissionMissing.title"),
      };
    }
    thisModal.show("error-modal", modal);
  },
  formatRole(roles) {
    let str = "";
    roles.forEach((role) => {
      str += i18n.t("roles." + role);
      str += ", ";
    });
    str = str.substring(0, str.length - 2);
    return str;
  },
  isDownloadable(status) {
    const statiBits = store.getters.global_get_fileStatiBits;
    return (
      (status & statiBits.VIRUS_SCAN_RESULT_OK.bit) === statiBits.VIRUS_SCAN_RESULT_OK.bit ||
      (status & statiBits.VIRUS_SCAN_RESULT_NA.bit) === statiBits.VIRUS_SCAN_RESULT_NA.bit
    );
  },
  globalIsBitSet(status, bit) {
    return (status & bit) === bit;
  },
  globalCheckFileStatus(status, config) {
    if (this.globalIsBitSet(status, config.CONVERTING.bit)) {
      return "CONVERTING";
    } else if (this.globalIsBitSet(status, config.CONVERTED.bit)) {
      return "CONVERTED";
    } else if (this.globalIsBitSet(status, config.CONVERSION_ERROR.bit)) {
      return "CONVERSION_ERROR";
    } else if (this.globalIsBitSet(status, config.VIRUS_SCAN_ERROR.bit)) {
      return "VIRUS_SCAN_ERROR";
    } else if (this.globalIsBitSet(status, config.VIRUS_SCAN_RESULT_INFECTED.bit)) {
      return "VIRUS_SCAN_RESULT_INFECTED";
    } else if (this.globalIsBitSet(status, config.VIRUS_SCANNING.bit)) {
      return "VIRUS_SCANNING";
    } else if (
      this.globalIsBitSet(status, config.VIRUS_SCAN_RESULT_OK.bit) ||
      this.globalIsBitSet(status, config.VIRUS_SCAN_RESULT_NA.bit)
    ) {
      return "VIRUS_SCAN_RESULT_OK";
    } else {
      return "ERROR";
    }
  },
  globalGetCurrentFileStatus(status, config) {
    return this.globalCheckFileStatus(status, config);
  },
  globalCheckSignedDocumentStatus(status, config) {
    if (this.globalIsBitSet(status, config.NEW.bit)) {
      return "NEW";
    } else if (this.globalIsBitSet(status, config.READY_TO_SIGN.bit)) {
      return "READY_TO_SIGN";
    } else if (this.globalIsBitSet(status, config.INIT_SIGNING.bit)) {
      return "INIT_SIGNING";
    } else if (this.globalIsBitSet(status, config.WAITING_ON_SIGNATURES.bit)) {
      return "WAITING_ON_SIGNATURES";
    } else if (this.globalIsBitSet(status, config.SIGNED.bit)) {
      return "SIGNED";
    } else if (this.globalIsBitSet(status, config.CANCELED.bit)) {
      return "CANCELED";
    } else if (this.globalIsBitSet(status, config.EXPIRED.bit)) {
      return "EXPIRED";
    } else if (this.globalIsBitSet(status, config.VISIBLE_TO_CLIENT.bit)) {
      return "VISIBLE_TO_CLIENT";
    } else {
      return "ERROR";
    }
  },
  globalGetCurrentSignedDocumentStatus(status, config) {
    return this.globalCheckSignedDocumentStatus(status, config);
  },
  globalCheckTemplateStatus(status, config) {
    if (this.globalIsBitSet(status, config.HIDDEN.bit)) {
      return "HIDDEN";
    } else if (this.globalIsBitSet(status, config.PUBLISHING.bit)) {
      return "PUBLISHING";
    } else if (this.globalIsBitSet(status, config.SEEDING.bit)) {
      return "SEEDING";
    } else {
      return "ERROR";
    }
  },
  globalCheckTemplateDraftStatus(status, config) {
    console.log(
      "******************** CHECK BITS",
      status,
      config.READY.bit,
      this.globalIsBitSet(status, config.READY.bit)
    );
    if (this.globalIsBitSet(status, config.CREATING.bit)) {
      return "CREATING";
    } else if (this.globalIsBitSet(status, config.PUBLISHING.bit)) {
      return "PUBLISHING";
    } else if (this.globalIsBitSet(status, config.RESETTING.bit)) {
      return "RESETTING";
    } else if (this.globalIsBitSet(status, config.PUBLISHED.bit)) {
      return "PUBLISHED";
    } else if (this.globalIsBitSet(status, config.MODIFIED.bit)) {
      return "MODIFIED";
    } else if (this.globalIsBitSet(status, config.READY.bit)) {
      return "READY";
    } else {
      return "ERROR";
    }
  },
  globalFormatThemeImage(url, width, height, renderMethod = "fit", page = 1, quality = "1") {
    return url
      .replace("{page}", page)
      .replace("{width}", width)
      .replace("{height}", height)
      .replace("{rendermethod}", renderMethod)
      .replace("{quality}", quality);
  },
  toggleVersion() {
    // remove ending / from path
    let v1Url = $config.switchVersion.url.v1;
    let v2Url = $config.switchVersion.url.v2;
    if (v1Url.endsWith("/")) v1Url = v1Url.slice(0, -1);
    if (v2Url.endsWith("/")) v2Url = v2Url.slice(0, -1);
    const dashboardPath = $router.resolve({ name: "Dashboard" });
    let url = v2Url + dashboardPath.href;
    if ($config.switchVersion.current === "v2") {
      url = url.replace(v2Url, v1Url) + "?redirectedFromNewVersion=true";
    } else {
      localStorage.setItem("newVersionActive", "isActive");
      url = url.replace(v1Url, v2Url);
    }
    window.location = url;
    console.log("end url", url);
    console.log("process.env", v1Url, v2Url, window.location.href);
  },
  removeURLParameter(url, parameter) {
    const urlparts = url.split("?");
    if (urlparts.length >= 2) {
      const prefix = encodeURIComponent(parameter) + "=";
      const pars = urlparts[1].split(/[&;]/g);
      for (let i = pars.length; i-- > 0; ) {
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
    }
    return url;
  },
  formatTemplateFileImage(url, width = 100, height = 100, renderMethod = "fit", page = 1, quality = "1") {
    return url
      .replace("{page}", page)
      .replace("{width}", width)
      .replace("{height}", height)
      .replace("{rendermethod}", renderMethod)
      .replace("{quality}", quality);
  },
  isTouchScreen() {
    try {
      document.createEvent("TouchEvent");
      return true;
    } catch (e) {
      return false;
    }
  },
  compare(a, b) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  },
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
};

export default helpers;
